/**
 * Production-safe logging utility
 * Automatically disables console logs in production builds
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  // For critical errors that should always show (even in production)
  critical: (...args) => {
    console.error('🚨 CRITICAL:', ...args);
  }
};

// Export for both CommonJS and ES modules
module.exports = logger;
module.exports.default = logger;
module.exports.logger = logger;
